export const NOMINATION_CLOSED_TEXT =
  "Nominations for this sale are now closed. Please contact the receiving agent.";
